<template>
  <div>
    <div class="container season">
      <h4 class="title">STANDINGS</h4>
      <div class="season-title">
        <p
          @click="seasonNumber = !seasonNumber"
          :class="seasonNumber ? 'active': ''"
        >{{season.num0}}</p>
        <p
          @click="seasonNumber = !seasonNumber"
          :class="!seasonNumber ? 'active': ''"
        >{{season.num1}}</p>
      </div>
      <div class="table vgt-wrap" v-if="seasonNumber">
        <div class="vgt-inner-wrap">
          <div class="vgt-responsive">
            <div class="table vgt-table">
              <div class="table-header">
                <div class="vgt-left-align">
                  <span>Position</span>
                </div>
                <div class="vgt-left-align">
                  <span>Team</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span>W</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span>D</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span>L</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span data-v-eb5a915e>GF</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span>GA</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span>GD</span>
                </div>
                <div class="vgt-left-align">
                  <span>Points</span>
                </div>
              </div>
              <div class="table-body">
                <div :class="rowStyleClassFn(team)" v-for="team in team1Sort" :key="team.id">
                  <div class="vgt-left-align">
                    <span>{{team.position}}</span>
                  </div>
                  <div class="vgt-left-align">
                    <div class="title">
                      <div class="img">
                        <img :src="team.logoUrl" />
                      </div>

                      <span>{{team.name}}</span>
                    </div>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].win}}</span>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].draw}}</span>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].lost}}</span>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].goalsFor}}</span>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].goalsAgainst}}</span>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].goalsDifferencial || 0}}</span>
                  </div>
                  <div class="vgt-left-align">
                    <span>{{team.points}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table vgt-wrap" v-else>
        <div class="vgt-inner-wrap">
          <div class="vgt-responsive">
            <div class="table vgt-table">
              <div class="table-header">
                <div class="vgt-left-align">
                  <span>Position</span>
                </div>
                <div class="vgt-left-align">
                  <span>Team</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span>W</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span>D</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span>L</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span data-v-eb5a915e>GF</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span>GA</span>
                </div>
                <div class="vgt-left-align secondary">
                  <span>GD</span>
                </div>
                <div class="vgt-left-align">
                  <span>Points</span>
                </div>
              </div>
              <div class="table-body">
                <div :class="rowStyleClassFn(team)" v-for="team in team2Sort" :key="team.id">
                  <div class="vgt-left-align">
                    <span>{{team.position}}</span>
                  </div>
                  <div class="vgt-left-align">
                    <div class="title">
                      <div class="img">
                        <img :src="team.logoUrl" />
                      </div>
                      <span>{{team.name}}</span>
                    </div>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].win}}</span>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].draw}}</span>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].lost}}</span>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].goalsFor}}</span>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].goalsAgainst}}</span>
                  </div>
                  <div class="vgt-left-align secondary">
                    <span>{{team.teamStats[0].goalsDifferencial || 0}}</span>
                  </div>
                  <div class="vgt-left-align">
                    <span>{{team.points}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="table-description">
        <p v-for="item in desriptionItems" :key="item.abb">
          <span>{{item.abb}}</span>
          - {{item.word}}
        </p>
      </div>
    </div>
    <BottomSection></BottomSection>
  </div>
</template>
<script>
const url = process.env.VUE_APP_URL;
const BottomSection = () => import("@/components/shared/BottomSection");

export default {
  data() {
    return {
      season: { num1: "", num2: "" },
      seasonTeam1: [],
      seasonTeam2: [],
      desription: [
        {
          abb: "W",
          word: "Win",
        },
        {
          abb: "D",
          word: "Draw",
        },
        {
          abb: "L",
          word: "Lost",
        },
        {
          abb: "GF",
          word: "Goals For",
        },
        {
          abb: "GA",
          word: "Goals Against",
        },
        {
          abb: "GD",
          word: "Goals Differencial",
        },
      ],
      seasonNumber: true,
    };
  },
  computed: {
    team1Sort() {
      var seasonTeam = [];
      this.seasonTeam1.map((el) => {
        el.teamStats.map((elem) => {
          elem.goalsDifferencial = elem.goalsFor - elem.goalsAgainst;
          if (elem.season.period == this.season) {
            return elem;
          }
        });
        if (el.teamStats.length != 0) {
          seasonTeam.push(el);
        }
      });
      this.sortPoints(seasonTeam);
      this.positionCheck(seasonTeam);
      return seasonTeam;
    },
    team2Sort() {
      var seasonTeam = [];
      this.seasonTeam2.map((el) => {
        el.teamStats.map((elem) => {
          elem.goalsDifferencial = elem.goalsFor - elem.goalsAgainst;
          if (elem.season.period == this.season) {
            return elem;
          }
        });
        if (el.teamStats.length != 0) {
          seasonTeam.push(el);
        }
      });
      this.sortPoints(seasonTeam);
      this.positionCheck(seasonTeam);
      return seasonTeam;
    },
    desriptionItems() {
      return this.desription;
    },
  },
  methods: {
    setTeams() {
      this.axios
        .get(url + "/teams", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          this.$store.dispatch("setTeams", payload);
        });
    },
    setSeasons() {
      this.axios
        .get(url + "/seasons", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          this.$store.dispatch("setSeasons", payload);
          setTimeout(() => {
            this.seasons();
          }, 100);
        });
    },
    seasons() {
      var season = this.$store.getters.seasons,
        item = {};
      var seasonNew = season.reverse().slice(-2);
      seasonNew.map((el, index) => {
        var seasonIndex = "num" + index;
        item[seasonIndex] = el.period;
      });

      this.season = item;
      season.filter((el) => {
        if (el.period == this.season.num0 && el.isMain) {
          this.seasonNumber = true;
        } else if (el.period == this.season.num1 && el.isMain) {
          this.seasonNumber = false;
        }
      });

      this.teamsSeasons();
    },
    teamsSeasons() {
      var teamsALL = JSON.parse(JSON.stringify(this.$store.getters.teams)),
        teamsALL2 = JSON.parse(JSON.stringify(this.$store.getters.teams)),
        season1 = [],
        season2 = [];

      teamsALL.map((el) => {
        var newState = [];
        el.teamStats.map((elem) => {
          if (elem.season.period == this.season.num0) {
            newState.push(elem);
          }
        });

        if (newState.length != 0) {
          el.teamStats = newState;
          season1.push(el);
        }
      });

      teamsALL2.map((el) => {
        var newState = [];
        el.teamStats.map((elem) => {
          if (elem.season.period == this.season.num1) {
            newState.push(elem);
          }
        });

        if (newState.length != 0) {
          el.teamStats = newState;
          season2.push(el);
        }
      });

      this.seasonTeam1 = season1;
      this.seasonTeam2 = season2;
    },
    rowStyleClassFn(el) {
      return el.name == "Bridgeport Utd" ? "active" : false;
    },
    sortPoints(arr) {
      arr.map((el) => {
        var points = 0;
        if (el.teamStats) {
          el.teamStats.map((elem) => {
            points = elem.win * 3 + elem.draw * 1;
          });
        }
        el.points = points;
      });
      arr.sort((a, b) => {
        if (a.points > b.points) {
          return -1;
        } else if (a.points == b.points) {
          var el1 = "",
            el2 = "";
          a.teamStats.map((el) => {
            el1 = el.goalsDifferencial;
          });
          b.teamStats.map((el) => {
            el2 = el.goalsDifferencial;
          });

          return el1 > el2 ? -1 : 1;
        } else {
          return 1;
        }
      });
    },
    positionCheck(arr) {
      arr.forEach(function (el, index) {
        el.position = index + 1;
      });
    },
  },
  mounted() {
    this.setTeams();
    this.setSeasons();
  },
  components: {
    BottomSection,
  },
};
</script>
<style lang="scss" scoped>
.season {
  padding-top: 9.5rem;
  @media only screen and (max-width: 650px) {
    padding-top: 3rem;
    padding-bottom: 5rem;
  }

  & > .title {
    margin-bottom: 1.8rem;
    & + .season-title {
      display: flex;
      p {
        font-size: 1.8rem;
        font-weight: 400;
        line-height: 1.7rem;
        color: #868686;
        margin-bottom: 1.5rem;
        margin-right: 4rem;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        &:hover {
          color: $textBlue;
        }
        &.active {
          color: $textBlue;
        }
        @media only screen and (max-width: 768px) {
          font-size: 1.5rem;
        }
      }
    }
  }
  .table-description {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 3rem 0 9rem;
    @media only screen and (max-width: 768px) {
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
    }
    @media only screen and (max-width: 650px) {
      display: none;
    }
    p {
      font-size: 1.4rem;
      color: #868686;
      font-weight: 400;
      letter-spacing: 0.5px;
      margin-right: 1rem;
      &:last-of-type {
        margin-right: 0;
      }
      span {
        font-weight: 500;
        color: #363636;
      }
    }
  }
}
</style>